import React from "react"
import SuspectForm from "./SuspectForm"
import puzzleAnswerData from "../puzzleAnswerData"

function Accusation(props) {
    return(
        <div className="accusationFormWrapper">
            <br />
            <SuspectForm correct={puzzleAnswerData[5].accusation} callBackSubmit={props.callBackSubmit} />
            <br />
        </div>
    )
}

export default Accusation